gsap.registerPlugin(ScrollTrigger);

const calcContainerWidth = () => window.innerWidth;
const calcWindowHeight = () => window.innerHeight;
const AppleMastheadDistanceFromTop = document.querySelector('#gsap-scrolltrigger-banner').getBoundingClientRect().top;

const tl = gsap.timeline({});

// NOTE: This item is not animated as part of timeline, does not scrub, is triggered when ~enters viewport
gsap.from('#gsap-scrolltrigger-banner h1', {
  x: '-750px',
  duration: 1,
  scrollTrigger: {
    // markers: true,
    trigger: '#gsap-scrolltrigger-banner h1',
    start: 'top 75%',
  }
});

// NOTE: The following items are animated as part of the timeline, scrubbed, and triggered by the #gsap-scrolltrigger-banner
tl.to('#gsap-scrolltrigger-banner > div', {
  backgroundColor: 'white',
  scrollTrigger: {
    // markers: true,
    trigger: '#gsap-scrolltrigger-banner',
    start: 'top top+=100px',
    end: 'top top',
    scrub: 1
  }
});

tl.to(['#gsap-scrolltrigger-banner h1', '#gsap-scrolltrigger-banner p'], {
  color: 'black',
  scrollTrigger: {
    // markers: true,
    trigger: '#gsap-scrolltrigger-banner',
    start: 'top top+=100px',
    end: 'top top',
    scrub: 1
  }
});

tl.from('#gsap-scrolltrigger-banner p', {
  y: '200px',
  scrollTrigger: {
    // markers: true,
    trigger: '#gsap-scrolltrigger-banner p',
    start: 'top bottom+=50px',
    end: 'top 90%',
    scrub: 2
  }
});

tl.fromTo('#yeety-images img', {
  rotate: -90,
}, {
  x: `-${calcContainerWidth() / 1.8}px`,
  y: `-${calcWindowHeight() * 1.7}px`,
  stagger: 1.5,
  duration: 12,
  rotate: 90,
  scrollTrigger: {
    // markers: true,
    scrub: 15,
    trigger: '#gsap-scrolltrigger-banner',
    start: `top 70%`,
    end: `top top-=700px`,
  },
});
